export const TIME_OUT_RENDER_CHART = 300



// WEBPACK FOOTER //
// ./app/pages/Dashboard/constants.js